
import {map} from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Http, Headers, Response, ResponseContentType,RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';

import { API } from '../../core/app-config';
import { FPResponse, GlobalInfo } from '../../shared/shared.model';
import { SharedService } from '../../shared/shared.service';
import { AddThresholdDetails, ThresholdDetails, InventoryDetails, SubstitutePart, UomList, Part, SavePart, Parts, Location, Warehouse, BrandList, ModelList, PartCategoryList, PartTypeList, SearchPart, SaveSubstitutePart, TaxGroup } from './part.model';
import { AttachmentsModel,PartFilterExcelEntity } from './part.model';
import { Company } from 'app/layout/company/company.models';
import { FileDetails } from 'app/layout/technician/technician-jobs/technician-jobs.models';

@Injectable()
export class PartService {

    constructor(private http: Http, sharedService: SharedService) { }

    getParts(CompanyId: number): Observable<Parts[]> {

        return this.http.get(API.PART + "/GetAll/" + CompanyId + '/?SortBy=Desc' + '&OrderBy=PartId').pipe(map(res => {
            var parts = <any>res.json();

            return parts.PartList;

        }));

    }
    DeleteAttachmentFile(model: FileDetails[]) {
        return this.http.post(API.WORKORDER + '/DeleteWOFile/', model).pipe(
            map(this.extractData));
    }

    getPart(CompanyId: number, Id: number): Observable<Part> {
        return this.http.get(API.PART + "/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }


    insert(savepart: SavePart): Observable<FPResponse> {
        return this.http.post(API.PART, savepart).pipe(map(res => res.json()));
    }

    update(savepart: SavePart): Observable<FPResponse> {
        return this.http.put(API.PART, savepart).pipe(map(res => res.json()));
    }
    updatePartDetails(savepart: SavePart): Observable<FPResponse> {debugger
        return this.http.put(API.PART + '/updatePartDetails/', savepart).pipe(map(res => res.json()));
    }

    delete(CompanyId: number, partId: number): Observable<FPResponse> {
        return this.http.delete(API.PART + '/' + CompanyId + '/' + partId).pipe(map(res => res.json()));
    }
    DeleteThreshold(CompanyId: number, partThresholdId: number): Observable<FPResponse> {
        return this.http.delete(API.PART + '/DeleteThreshold/' + CompanyId + '/' + partThresholdId).pipe(map(res => res.json()));
    }

    DeleteSubstitutePart(CompanyId: number, substitutePart: number): Observable<FPResponse> {
        return this.http.delete(API.PART + '/DeleteSubstitutePart/' + CompanyId + '/' + substitutePart).pipe(map(res => res.json()));
    }


    getLocation(CompanyId: number): Observable<Location[]> {
        return this.http.get(API.PART + '/GetLocation/' + CompanyId).pipe(map(res => res.json()));
    }
    getWarehouse(CompanyId: number): Observable<Warehouse[]> {
        return this.http.get(API.PART + '/GetWarehouse/' + CompanyId).pipe(map(res => res.json()));
    }
    getBrandList(CompanyId: number): Observable<BrandList[]> {
        return this.http.get(API.PART + '/GetBrandList/' + CompanyId).pipe(map(res => res.json()));
    }
    getModelList(CompanyId: number, brandId: number): Observable<ModelList[]> {
        return this.http.get(API.PART + '/GetModelList/' + CompanyId + '/' + brandId).pipe(map(res => res.json()));
    }
    getPartCategoryList(CompanyId: number): Observable<PartCategoryList[]> {
        return this.http.get(API.PART + '/GetPartCategoryList/' + CompanyId).pipe(map(res => res.json()));
    }
    getPartTypeList(CompanyId: number): Observable<PartTypeList[]> {
        return this.http.get(API.PART + '/GetPartTypeList/' + CompanyId).pipe(map(res => res.json()));
    }
    getUomList(CompanyId: number): Observable<UomList[]> {
        return this.http.get(API.PART + '/GetUomList/' + CompanyId).pipe(map(res => res.json()));
    }

    GetBysearch(part: SearchPart): Observable<Parts[]> {

        return this.http.post(API.PART + '/GetPartSearch/' + '/?SortBy=Desc' + '&OrderBy=PartId', part).pipe(map(res => {
            var parts = <any>res.json();
            return parts.PartList;

        }));

    }
    InsertSubstitutePart(objValue: SaveSubstitutePart[]): Observable<FPResponse> {

        return this.http.post(API.PART + '/SaveSubstitutePart/', objValue).pipe(map(res => res.json()));
    }

    insertThresholdDetails(addThresholdDetails: AddThresholdDetails): Observable<FPResponse> {
        return this.http.post(API.PART + '/InsertThresholdDetails/', addThresholdDetails).pipe(map(res => res.json()));
    }

    updateThresholdDetails(addThresholdDetails: AddThresholdDetails): Observable<FPResponse> {
        return this.http.put(API.PART + '/UpdateThresholdDetails/', addThresholdDetails).pipe(map(res => res.json()));
    }

    getThresholdDetails(CompanyId: number, PartId: number): Observable<ThresholdDetails[]> {

        return this.http.get(API.PART + "/GetThresholdDetails/" + CompanyId + "/" + PartId).pipe(map(res => {
            var thresholddetails = <any>res.json();

            return thresholddetails.ThresholdDetList;
        }));
    }

    getThreshold(CompanyId: number, Id: number): Observable<ThresholdDetails> {
        return this.http.get(API.PART + '/GetThreshold/' + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    getSubstitutePart(CompanyId: number, PartId: number): Observable<SubstitutePart[]> {

        return this.http.get(API.PART + "/GetAllSubstitutePart/" + CompanyId + "/" + PartId).pipe(map(res => {
            var substituteparts = <any>res.json();

            return substituteparts.SubPartList;

        }));

    }



    getInventoryDetails(CompanyId: number, PartId: number, LoginId: number): Observable<InventoryDetails[]> {

        return this.http.get(API.PART + "/GetInventoryDetails/" + CompanyId + "/" + PartId + "/" + LoginId).pipe(map(res => {
            var inventorydetails = <any>res.json();

            return inventorydetails.InventoryDetList;

        }));

    }
    getTaxGroup(CompanyId: number, TaxTypeId: number): Observable<TaxGroup[]> {
        return this.http.get(API.TAXGROUPMASTER + "/GetTaxGroup/?CompanyId=" + CompanyId + '&TaxTypeId=' + TaxTypeId).pipe(map(res => res.json()));
    }

    saveAttachement(model: AttachmentsModel[]) {

        return this.http.post(API.PART + '/ManageWoSaveAttachment/', model).pipe(
            map(this.extractData));
    }

    getAttachementsDetails(companyId: number, filterBy: number, PartId: number): Observable<AttachmentsModel[]> {
        return this.http.get(API.PART + '/GetManageWoAllAttachement' + '?CompanyId=' + companyId + '&FilterBy=' + filterBy + '&PartId=' + PartId).pipe(
            map(this.extractData));
    }

    deleteAttachement(companyId: number, PartAttachmentId: number): Observable<FPResponse> {

        return this.http.delete(API.PART + '/DeleteAttachment' + '?CompanyId=' + companyId + '&PartAttachmentId=' + PartAttachmentId).pipe(
            map(this.extractData));
    }
    //Added by Arumugam 21-feb-2019  For PartExcelDownload 
   getPartExcel(PartExcelDownloadFilters: PartFilterExcelEntity) {
    return this.http.post(API.PART + "/PartExcelDownload/", PartExcelDownloadFilters,{responseType:ResponseContentType.Blob}).pipe();
    }
    getCompany(companyId: number): Observable<Company> {
        return this.http.get(API.COMPANY + '/Get/?CompanyId=' + companyId).pipe(map(res => res.json()));
    }

    private extractData(res: Response) {
        //  
        let body = res.json();
        return body || {};
    }

}


